var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("经营者收入申报")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("经营者收入申报"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "姓名" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入姓名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c("el-form-item", { attrs: { label: "年份" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: { placeholder: "选择年份" },
                                      model: {
                                        value: _vm.ruleForm.year,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "year", $$v)
                                        },
                                        expression: "ruleForm.year",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "2025年",
                                          value: "2025",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "2026年",
                                          value: "2026",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "2027年",
                                          value: "2027",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "2028年",
                                          value: "2028",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "2029年",
                                          value: "2029",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c("el-form-item", { attrs: { label: "月份" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: { placeholder: "选择月份" },
                                      model: {
                                        value: _vm.ruleForm.mounth,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "mounth", $$v)
                                        },
                                        expression: "ruleForm.mounth",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "1月", value: "1" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "2月", value: "2" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "3月", value: "3" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "4月", value: "4" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "5月", value: "5" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "6月", value: "6" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "7月", value: "7" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "8月", value: "8" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "9月", value: "9" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "10月", value: "10" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "11月", value: "11" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "12月", value: "12" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "待申报", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已申报", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList("new")
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.InvoicingAll()
                      },
                    },
                  },
                  [_vm._v("批量申报")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.dowon()
                      },
                    },
                  },
                  [_vm._v("税务申报模板下载")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.exportList(2)
                      },
                    },
                  },
                  [_vm._v("导出申报excel")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("TableScrollSlider", {
              attrs: { "table-ref": _vm.$refs.multipleTable },
            }),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "hasRegisterCert",
                    label: "是否已取得等级证照",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "month", label: "月份", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "memberName",
                    label: "(名称)姓名",
                    align: "center",
                    width: "150",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "licenseNo",
                    label: "统一社会信用代码(纳税人识别号)",
                    align: "center",
                    width: "170",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "incomeFrom",
                    label: "收入来源的互联网平台名称",
                    align: "center",
                    width: "130",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "incomeCustomName",
                    label: "收入来源的店铺(用户)名称",
                    align: "center",
                    width: "130",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "incomeCustomId",
                    label: "收入来源的店铺(用户)唯一标识码",
                    align: "center",
                    width: "130",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "unRegisterCertCode",
                    label: "证件号码",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleGoodIncomeAmount",
                    label: "销售货品收入总额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleGoodRefundAmount",
                    label: "销售货品退款金额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleGoodNetAmount",
                    label: "销售货品收入净额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleIntangibleIncomeAmount",
                    label: "销售无形资产收入总额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleIntangibleRefundAmount",
                    label: "销售无形资产退款金额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleIntangibleNetAmount",
                    label: "销售无形资产收入净额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleServerIncomeAmount",
                    label: "销售服务收入总额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleServerRefundAmount",
                    label: "销售服务退款金额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleServerNetAmount",
                    label: "销售服务收入净额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "unregisterIncomeAmount",
                    label: "未登记收入总额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "unregisterRefundAmount",
                    label: "未登记退款金额",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "unregisterTotalAmount",
                    label: "未登记小计",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "saleGoodAmount",
                    label: "销售货物",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "transportService",
                    label: "运输服务",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "serviceRemuneration",
                    label: "劳务报酬",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "royalty", label: "稿酬", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "franchiseFee",
                    label: "特许权使用费",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "networkNetIncome",
                    label: "从事其他网络交易活动取得的收入(净额)",
                    align: "center",
                    width: "150",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "paidToPlatform",
                    label: "支付给平台的佣金、服务费合计金额",
                    align: "center",
                    width: "150",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderNum",
                    label: "交易(订单)数量(笔)",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("待申报"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已申报"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "创建时间",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    fixed: "right",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("div", { staticClass: "disAround" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.Invoicing(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                提交申报\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "operateBtn",
                              on: {
                                click: function ($event) {
                                  return _vm.goDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n              查看明细\n            ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [20, 30, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible1,
            width: "40%",
            "before-close": _vm.handleClose1,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible1 = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "350px", "overflow-y": "scroll" } },
            _vm._l(_vm.errorList, function (item, index) {
              return _c("div", { key: index }, [_vm._v(_vm._s(item))])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible1 = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }